import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "../../../../styles/lead-mangement/lms-table.css";
import {
  convertThenFormat,
  formatDateTime,
} from "../../../common-data/Converts";
import {
  EditIcon,
  BinIcon,
  CalendarIcon,
  FolderIcon,
  SendIcon,
  CallIcon,
} from "../../../../images/icons/icons";
import Table from "../lms-customised-comps/Table";
import LMSFollowups from "./LMSFollowups";
import LMSFDReports from "./LMSFDReports";
import { commonUpdate } from "../../../../redux/reducers/putApiSlice";
import { deleteUpdateLead } from "../../../../data/ApiEndpoints";
import { showConfirmAlert } from "../../../components-react/ReactAlert";
import BulkAssignButtons from "../lms-customised-comps/BulkAssignButtons";
import LeadsLogsCard from "../../fully-customised/LeadsLogsCard";

const tabList = [
  "Leads View",
  "Today's Follow-ups",
  "Missed Follow-ups",
  // "Reports View",
];

const LMSTabs = ({
  activeTab,
  setActiveTab,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
  callFunction,
  tabsRef,
}) => {
  const dispatch = useDispatch();
  const { allLeads, allLeadsLoading, allLeadsError } = useSelector(
    (state) => state.api
  );

  const iniLeadsDatas = {
    data: [],
    pagination: [],
  };
  const [leadsDatas, setLeadsDatas] = useState(iniLeadsDatas);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelectedDisabled, setIsAllSelectedDisabled] = useState(false);

  const handleDelete = async (payload, rowData) => {
    if (payload?.lead_id && payload.status) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonUpdate({
              endPoint: deleteUpdateLead,
              requestBody: payload,
              filters: "",
              TOKEN: userInfoData?.token,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Lead is deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete Lead!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete Lead");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete this Lead - ${rowData?.name}!`
      );
    } else {
      toast.error("Lead Id required!");
    }
  };

  function handleCheckbox(e, row) {
    const checked = e.target.checked;
    if (row === null) {
      if (checked) {
        setSelectedRows(leadsDatas.data.map((lead) => lead));
      } else {
        setSelectedRows([]);
      }
    } else {
      if (checked) {
        setSelectedRows((prev) => [...prev, row]);
      } else {
        setSelectedRows((prev) =>
          prev.filter((item) => item.lead_id !== row.lead_id)
        );
      }
    }
  }

  useEffect(() => {
    if (
      !allLeadsLoading &&
      !allLeadsError &&
      allLeads?.status &&
      allLeads?.data
    ) {
      setLeadsDatas((prev) => ({
        ...prev,
        data: allLeads.data,
        pagination: allLeads?.pagination,
      }));
    } else {
      setLeadsDatas(iniLeadsDatas);
    }
  }, [allLeadsLoading, allLeadsError, allLeads]);

  useEffect(() => {
    const allConvertedOrClosed = leadsDatas.data.every(
      (row) =>
        row?.lead_status?.toLowerCase() === "converted" ||
        row?.lead_status?.toLowerCase() === "closed"
    );

    if (allConvertedOrClosed) {
      setIsAllSelectedDisabled(true);
    } else {
      setIsAllSelectedDisabled(false);
    }
  }, [leadsDatas.data]);

  const leadColumns = [
    {
      header: (
        <div
          className="checkbox-container"
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          <input
            type="checkbox"
            checked={
              leadsDatas.data.length > 0 &&
              selectedRows.length === leadsDatas.data.length
            }
            indeterminate={
              selectedRows.length > 0 &&
              selectedRows.length < leadsDatas.data.length
            }
            onChange={(e) => handleCheckbox(e, null)}
          />
          <span>lead INFO</span>
        </div>
      ),
      key: "customer_info",
      render: (lead) => (
        <div
          style={{
            background: selectedRows?.some(
              (row) => row.lead_id === lead?.lead_id
            )
              ? "#f0f6ff"
              : "transparent",
            borderRadius: 8,
            padding: "8px 0",
          }}
        >
          <div
            className="checkbox-container"
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <input
              type="checkbox"
              checked={selectedRows.some(
                (row) => row.lead_id === lead?.lead_id
              )}
              onChange={(e) => handleCheckbox(e, lead)}
            />
            <div>
              <div
                className="link"
                style={{ fontWeight: 600, fontSize: 15, color: "#111827" }}
                onClick={() =>
                  setModValues({
                    isModOpen: true,
                    modName: "view",
                    rowData: lead,
                  })
                }
              >
                {lead?.name || "NA"}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 13,
                  color: "#6b7280",
                  marginTop: 2,
                }}
              >
                <span role="img" aria-label="phone" style={{ fontSize: 13 }}>
                  📞
                </span>
                {lead?.mobile ? `+91 ${lead.mobile || ""}` : ""}
              </div>
              {lead.email && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    fontSize: 13,
                    color: "#6b7280",
                    marginTop: 2,
                    textTransform: "lowercase",
                  }}
                >
                  <span role="img" aria-label="email" style={{ fontSize: 13 }}>
                    ✉️
                  </span>
                  {lead.email}
                </div>
              )}
              {lead?.mem_lead_stage && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    fontSize: 13,
                    color: "#6b7280",
                    marginTop: 2,
                    textTransform: "capitalize",
                  }}
                >
                  <span>
                    <FolderIcon />
                  </span>
                  <span className="mem-lead-stage-highlight">
                    {lead.mem_lead_stage}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      ),
    },
    {
      header: "Lead STATUS",
      key: "stage_status",
      render: (lead) => (
        <div>
          <span
            className={`custom-status-badge ${
              lead?.lead_status === "pending"
                ? "custom-status-pending-followup"
                : lead?.lead_status === "converted"
                ? "custom-status-converted"
                : "custom-status-other"
            }`}
          >
            {lead?.lead_status === "pending"
              ? "Pending Follow-up"
              : lead?.lead_status?.replace(/_/g, " ")}
          </span>
        </div>
      ),
    },
    {
      header: "Current followup stage",
      key: "follow_up_number",
      render: (lead) => (
        <div
          style={{
            fontWeight: 600,
            color: "#111827",
            fontSize: 15,
          }}
        >
          {lead?.follow_up_number || 0}

          <div style={{ color: "#16a34a", fontSize: 13, fontWeight: 500 }}>
            {lead?.followup_days_count || 0} time(S)
          </div>
        </div>
      ),
    },
    {
      header: "Last followup status",
      key: "current_followup_status",
      render: (lead) => (
        <div>
          <div
            style={{ color: "#374151", fontSize: 13 }}
            className="minWidth200"
          >
            {lead?.current_followup_status?.replace(/_/g, " ") || "NA"}
          </div>
          <div
            style={{
              color:
                lead?.cutomer_intent?.toLowerCase() === "interested"
                  ? "#16a34a"
                  : "#D7263D",
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            {lead?.cutomer_intent?.replace(/_/g, " ") || ""}
          </div>
          <div
            style={{
              color:
                lead?.next_followup_date &&
                new Date(lead?.next_followup_date?.split(" ")[0]) < new Date()
                  ? "#dc2626"
                  : "#6b7280",
              fontWeight: 500,
              fontSize: 12,
              marginTop: 2,
            }}
          >
            Next:{" "}
            {lead?.next_followup_date
              ? formatDateTime(lead.next_followup_date)
              : ""}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13,
              marginTop: 2,
              cursor: "pointer",
            }}
          >
            <span
              className="assignee-status-dot"
              style={{
                "--dot-color":
                  lead?.assigned_to_status === "active" ? "#16a34a" : "#dc2626",
              }}
            />

            <span
              style={{
                color: "#2563eb",
                textDecoration: "underline",
              }}
            >
              assigned to - {lead?.assigned_to_name || ""}
            </span>
          </div>
        </div>
      ),
    },
    {
      header: "VALUE (₹)",
      key: "lead_value",
      render: (lead) => (
        <div>
          <div
            style={{
              color: "#111827",
              fontWeight: 500,
              fontSize: 13,
            }}
            className="minWidth100"
          >
            ₹{convertThenFormat(lead?.lead_value || 0)}
          </div>

          {lead?.duration && (
            <div style={{ color: "#374151", fontSize: 12, marginTop: 2 }}>
              plan: {lead.duration?.replace(/_/g, " ") || ""}
            </div>
          )}

          {lead.converted_value > 0 && (
            <div style={{ color: "#16a34a", fontSize: 12, fontWeight: 500 }}>
              converted @ ₹{convertThenFormat(lead.converted_value)}
            </div>
          )}
        </div>
      ),
    },
    {
      header: "SOURCE & BRANCH",
      key: "source_branch",
      render: (lead) => (
        <div>
          <div
            style={{ fontWeight: 500, color: "#111827", fontSize: 14 }}
            className="minWidth200"
          >
            {lead?.gym_name || "NA"}
          </div>
          <div className="cus-up-sp" style={{ color: "#6b7280", fontSize: 12 }}>
            {lead?.source_name?.replace(/_/g, " ") || ""} (
            {!lead?.utm_source
              ? "Organic"
              : lead?.utm_source?.replace(/_/g, " ") || ""}
            )
          </div>
          <div
            style={{
              color: "#2563eb",
              fontSize: 13,
              marginTop: 2,
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            added by - {lead?.added_by_name || ""}
          </div>
        </div>
      ),
    },
    {
      header: "CALL ACTIVITY",
      key: "call_activity",
      render: (lead) => (
        <div className="minWidth100">
          <div
            className="link"
            style={{ color: "#374151", fontSize: 13 }}
            onClick={() =>
              setModValues({
                isModOpen: true,
                modName: "total_outgoing_call",
                rowData: lead,
              })
            }
          >
            {lead?.total_outgoing_call || 0} calls made
          </div>
          <div
            className="underline"
            style={{
              color: "#16a34a",
              fontWeight: 600,
              fontSize: 13,
              cursor: "pointer",
            }}
            onClick={() =>
              setModValues({
                isModOpen: true,
                modName: "total_outgoing_connected_call",
                rowData: lead,
              })
            }
          >
            {lead?.total_outgoing_connected_call || 0} connected
          </div>
        </div>
      ),
    },
    {
      header: "Quick Actions",
      key: "actions",
      render: (lead) => {
        const isLeadClosedOrConverted =
          lead?.lead_status?.toLowerCase() === "closed" ||
          lead?.lead_status?.toLowerCase() === "converted";

        return (
          <div className="lms-action-btn-row">
            <div className="lms-action-quick-row">
              <button
                type="button"
                className={`lms-action-icon-btn ${
                  isLeadClosedOrConverted ? "disabled" : ""
                }`}
                disabled={isLeadClosedOrConverted}
                onClick={() =>
                  !isLeadClosedOrConverted &&
                  setModValues({
                    isModOpen: true,
                    modName: "edit",
                    rowData: lead,
                  })
                }
              >
                <EditIcon />
              </button>

              <button
                type="button"
                className={`lms-action-icon-btn ${
                  isLeadClosedOrConverted ? "disabled" : ""
                }`}
                disabled={isLeadClosedOrConverted}
                onClick={() => {
                  if (!isLeadClosedOrConverted) {
                    setModValues({
                      isModOpen: true,
                      modName: "followup",
                      rowData: lead,
                    });
                  }
                }}
              >
                <CalendarIcon />
              </button>

              <button
                type="button"
                className={`lms-action-icon-btn`}
                onClick={() => {
                  setModValues({
                    isModOpen: true,
                    modName: "click-to-call",
                    rowData: lead,
                  });
                }}
              >
                <CallIcon />
              </button>

              <button
                type="button"
                className={`lms-action-icon-btn`}
                onClick={() => {
                  setModValues({
                    isModOpen: true,
                    modName: "send-payment-link",
                    rowData: lead,
                  });
                }}
              >
                <SendIcon />
              </button>

              <button
                type="button"
                className={`lms-action-icon-btn ${
                  isLeadClosedOrConverted ? "disabled" : ""
                }`}
                disabled={isLeadClosedOrConverted}
                onClick={() => {
                  if (!isLeadClosedOrConverted) {
                    const payload = {
                      lead_id: lead?.lead_id,
                      status: "deleted",
                    };
                    handleDelete(payload, lead);
                  }
                }}
              >
                <BinIcon />
              </button>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="lms-v2-tabs-container" ref={tabsRef}>
        {tabList.map((tab, idx) => (
          <div
            key={tab}
            className={`lms-v2-tab ${
              activeTab === idx ? "lms-v2-tab-active" : ""
            }`}
            onClick={() => setActiveTab(idx)}
            style={{ cursor: "pointer" }}
          >
            {tab}
          </div>
        ))}
      </div>

      {activeTab === 0 ? (
        <>
          {selectedRows?.length > 0 ? (
            <BulkAssignButtons
              heading={
                isAllSelectedDisabled
                  ? "All the leads either closed or converted"
                  : `Re Assign Selected ${selectedRows?.length || 0} Leads`
              }
              submitText="Bulk Assign Agent"
              cancelText="clear selection"
              onSubmit={() => {
                setModValues({
                  isModOpen: true,
                  modName: "re-assign",
                  selectedRows: selectedRows,
                });
              }}
              onCancel={() => {
                setSelectedRows([]);
                setIsAllSelectedDisabled(false);
              }}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
          ) : null}

          <div className="hideMobile">
            <Table
              columns={leadColumns}
              data={leadsDatas.data}
              isPage={isPage}
              setIsPage={setIsPage}
              paginationArray={leadsDatas.pagination}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              isLoading={allLeadsLoading}
            />
          </div>

          <div className="lead-logs-card-container only-mobile">
            <LeadsLogsCard
              tableData={leadsDatas.data}
              tablePagination={leadsDatas.pagination}
              setClickValues={setModValues}
              handleDelete={handleDelete}
              isLeadLoading={allLeadsLoading}
              userInfoData={userInfoData}
              handleCheckboxChange={handleCheckbox}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </div>
        </>
      ) : activeTab === 1 || activeTab === 2 ? (
        <LMSFollowups
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isMissed={activeTab === 2}
          userInfoData={userInfoData}
          setModValues={setModValues}
          callFunction={callFunction}
        />
      ) : activeTab === 3 ? (
        <LMSFDReports
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      ) : (
        <div
          style={{
            padding: 40,
            textAlign: "center",
            color: "#6b7280",
            fontSize: 20,
          }}
        >
          {tabList[activeTab]} content goes here.
        </div>
      )}
    </>
  );
};

export default LMSTabs;
